import { Settings } from './settings';
import { MemberInterface } from './member-interface';

export class Member implements MemberInterface {
  public id: number;
  public person_id: number;
  public properties?: any;
  public consents: any;
  public sms_status: string;
  public email_status: string;
  public push_status: string;
  public created_at: string;
  public updated_at: string;

  constructor(config) {
    Object.keys(config).forEach(attribute => {
      this[attribute] = config[attribute];
    });
  }

  public isSmsVerified(settings: Settings): boolean {
    return !!settings.schema.properties.msisdn && this.sms_status === 'verified';
  }

  public isEmailVerified(settings: Settings): boolean {
    return !!settings.schema.properties.email && ['verified', 'unsubscribed'].includes(this.email_status);
  }

  public hasProperty(property: string): boolean {
    return !!this.properties?.[property];
  }
}
